import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentUserLicence } from '../features/auth/authSlice';

const useLicence = () => {
  const licence = useSelector(getCurrentUserLicence);
  return useMemo(() => ({ licence }), [licence]);
};
export default useLicence;
